<template>
  <div>
    <v-row>
      <v-col v-for="item in shown" :key="item.id" cols="12" sm="6" lg="4" xl="3">
        <v-card class="pa-3 pa-md-6">
          <v-img v-if="item.photo" :src="item.photo" width="100%" max-height="100" class="mb-3" contain></v-img>
          <router-link :to="{ name: 'Produit', params: { id: item.id }, query: { ...$route.query } }">
            <h4 class="subtitle-2">{{ item.titre }}</h4>
          </router-link>
          <p class="caption mb-0">{{ item.categorie[$i18n.locale] }}</p>
          <p class="caption mb-0">{{ item.langue.id ? item.langue[$i18n.locale] : "" }}</p>
          <p class="text-right font-weight-bold">{{ item.prix | money }}</p>

          <v-btn block text color="primary" small @click="ADD_ITEM(item)">{{ $t("boutique.ajouterAuPanier") }}</v-btn>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center mt-12">
      <v-btn v-if="shown.length < produits.length" color="primary" @click="index++">{{ $t("boutique.voirPlus") }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  data() {
    return {
      packSize: 20,
      index: 1
    }
  },
  props: {
    produits: Array
  },
  computed: {
    shown() {
      return this.produits.slice(0, this.packSize * this.index)
    }
  },
  methods: {
    ...mapActions(["ADD_ITEM"])
  }
}
</script>

<style>
</style>